import { render, staticRenderFns } from "./hutchdutchgameresults.vue?vue&type=template&id=2339c07b"
import script from "./hutchdutchgameresults.vue?vue&type=script&lang=js"
export * from "./hutchdutchgameresults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports